module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/artillery-strike-toolbar.f96a7cae.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/artillery-strike-toolbar.png
// module id = 3703
// module chunks = 11